export class TimelineContactForm {
  constructor(
    readonly id: string,
    readonly createdAt: string,
    readonly channelId: string,
  ) {}
}
